<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Run from "./run.vue";
export default {
  extends: baseList,
  components: {

    Run,
  },
  data() {
    return {
      table: {
        mname: "job",
        key: "jobId",
        url: {
          del: "/admin/monitor/job",
        },
        output: false,
      },
      actions: [
        {
          label: "新增任务",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "admin/job/add",
        },
      ],

      filters: [
        {
          label: "任务名称",
          name: "jobName",
          value: "",
          KeyEnter : this.search,
          type: "input",
        },
      ],
      tableCols: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: "任务名称",
          key: "jobName",
          minWidth: 120,
          align: "center",
        },
        {
          title: "任务组名",
          key: "jobGroup",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.jobGroup == "SYSTEM"
                ? "系统"
                : row.jobGroup == "DEFAULT"
                ? "默认"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "调用目标字符串",
          key: "invokeTarget",
          minWidth: 120,
          align: "left",
        },
        {
          title: "cron执行表达式",
          key: "cronExpression",
          minWidth: 120,
          align: "left",
        },
        {
          title: "状态",
          key: "status",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const color =
              row.status == 0 ? "blue" : row.status == 1 ? "red" : "";
            const text =
              row.status == 0 ? "正常" : row.status == 1 ? "暂停" : "";
            return (
              <span style={{ color: color, "font-size": "14px" }}>{text}</span>
            );
          },
        },
        // {
        //   title: '创建时间',
        //   minWidth: 180,
        //   align: 'left',
        //   key: 'createTime',
        // },
        {
          title: "操作",
          align: "center",
          width: 250,
          key: "handle",
          handle: [
            "edit",
            "delete",
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [{ name: 'auth', value: 'admin/job/run' }]
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.torun(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff",marginLeft: "5px" }}
                >
                  执行一次
                </Button>
              );
            },
          ],
          auth: {
            edit: "admin/job/edit",
            del: "admin/job/delete",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    //执行
    torun(row) {
      this.$Modal.success({
        closable: true,
        title: "执行一次",
        width: "400px",
        height: "100px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Run
              style={{ margin: "0", color: "#19be6b" }}
              jobId={row.jobId}
            ></Run>
          );
        },
      });
    },
    toAdd() {
      $utils.url.push({ name: "job_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "job_edit",
        query: { action: "edit", kv: currentRow.jobId },
      });
    },
    //转单
    // toChange(row) {},
    //详情
    // toInfo(row) {
    //   $utils.url.push({
    //     name: 'knowledgeBase_info',
    //     query: { action: 'edit', kv: row.id },
    //   })
    // },
    //导出
    toImport() {},
    //下载模板
    toDownload() {},
  },
};
</script>
<style scoped></style>
